import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../state/authStore";
import { useTeamStore } from "../state/teamStore";

function FullPageSpinner() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <div className="spinner" style={{ width: 32, height: 32 }} />
    </div>
  );
}

function allowNoTeam(pathname: string) {
  return (
    pathname.startsWith("/join/") ||
    pathname === "/onboarding/team/new"
  );
}

export default function TeamOnboardingGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { user } = useAuthStore();
  const { teams, loading, initialized, fetchTeams } = useTeamStore();

  useEffect(() => {
    if (user && !initialized && !loading) {
      void fetchTeams();
    }
  }, [user, initialized, loading, fetchTeams]);

  if (!user) {
    return <>{children}</>;
  }

  if (!allowNoTeam(location.pathname) && (!initialized || loading)) {
    return <FullPageSpinner />;
  }

  if (!allowNoTeam(location.pathname) && initialized && teams.length === 0) {
    return <Navigate to="/onboarding/team/new" replace />;
  }

  return <>{children}</>;
}
